import React from "react";
import { processImagePath } from "../../util/Functions";
import CatalogContext from "../../contexts/CatalogContext";
import { useCatalogSelectionContext } from "../../hooks/useCatalogSelectionContext";

import "./BrandLogoNav.scss";

/**
 *
 * @param {"retailer"|"vendor"|"select"} type
 */
export default function BrandLogoNav({ type }){

	const organization_logo_data = JSON.parse(localStorage.getItem('organization_member:data')) || undefined
	const [catalog] = React.useContext(CatalogContext);
	const showOrgLogo = !catalog || type === "vendor";
	const CatalogSelectionContext = useCatalogSelectionContext();

	const logo_click = () => {
		if (!catalog) {
			CatalogSelectionContext.clearSearch();
		}
	}
	
	const headerConfig = catalog?.options?.appearance?.header;
	const classes = ['logo-size']
		.map(key => headerConfig && headerConfig[key] && `${key}-${headerConfig[key]}`);
	
	const logoSrc = showOrgLogo
		? (organization_logo_data?.organization?.logo || organization_logo_data?.organization?.parent?.logo)
		: catalog?.options?.branding?.logo;
	
    if (logoSrc) {
		const logoAlt = showOrgLogo ? organization_logo_data?.organization?.name : catalog?.options?.branding?.name;

        return (
	        <div data-component="BrandLogoNav" className={classes.filter(f=>f).join(" ")}>
		        <div className="brand-logo">
			        <img
				        alt={logoAlt}
				        className="brand-logo-img"
				        onClick={logo_click}
				        src={processImagePath(logoSrc, "full")}
			        />
		        </div>
	        </div>
        )
    }
}